export default __webpack_public_path__ + "static/4-d47822de23dd3dd134a52ffe6fb70e8b.png";